import React, { useEffect } from "react";
import { X } from "lucide-react";

export default function ShopModal({ title, icon: Icon, dark, onClose, children, testid }) {
  useEffect(() => {
    document.body.style.overflow = "hidden";
    const esc = (e) => e.key === "Escape" && onClose();
    document.addEventListener("keydown", esc);
    return () => { document.body.style.overflow = ""; document.removeEventListener("keydown", esc); };
  }, [onClose]);

  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center p-4" data-testid={testid || "shop-modal"}>
      <div className="fixed inset-0 bg-black/45 backdrop-blur-md" onClick={onClose} style={{ animation: "jnFade .25s both" }} />
      <div
        className={`relative w-full max-w-lg max-h-[85vh] overflow-y-auto rounded-3xl p-7 sm:p-8 shadow-2xl ${dark ? "bg-[#101830] border border-white/10 text-white" : "bg-white text-slate-900"}`}
        style={{ animation: "jnModalIn .35s cubic-bezier(.22,1,.36,1) both" }}
      >
        <button onClick={onClose} className={`absolute top-4 right-4 p-2 rounded-full transition-colors ${dark ? "hover:bg-white/10 text-slate-400" : "hover:bg-slate-100 text-slate-400"}`} data-testid="shop-modal-close" aria-label="Fermer">
          <X className="h-4 w-4" />
        </button>
        {Icon && (
          <span className={`inline-flex h-12 w-12 items-center justify-center rounded-2xl mb-4 ${dark ? "bg-emerald-500/15 text-emerald-300" : "bg-emerald-50 text-emerald-600"}`}>
            <Icon className="h-6 w-6" />
          </span>
        )}
        {title && <h3 className="text-lg font-bold tracking-tight mb-3">{title}</h3>}
        <div className={`text-sm leading-relaxed ${dark ? "text-slate-300" : "text-slate-600"}`}>{children}</div>
      </div>
      <style>{`@keyframes jnFade{from{opacity:0}to{opacity:1}}@keyframes jnModalIn{from{opacity:0;transform:translateY(16px) scale(.97)}to{opacity:1;transform:none}}`}</style>
    </div>
  );
}
